import { ButtonMantine, ButtonProps, Card, CardProps, Group } from 'ui';

type InformationCardProps = {
  text: React.ReactNode;
  buttonProps: ButtonProps;
  isButtonVisible?: boolean;
  radius?: CardProps['radius'];
};

const InformationCard = ({
  text,
  buttonProps,
  isButtonVisible = true,
  radius = 'md',
}: InformationCardProps) => {
  return (
    <Card radius={radius} bg="slate" mih={32}>
      <Group gap={'md'} align={'center'} justify="space-between" wrap="nowrap">
        {text}

        {isButtonVisible && (
          <ButtonMantine size="sm" variant="outline" color="white" {...buttonProps} />
        )}
      </Group>
    </Card>
  );
};

export { InformationCard };
